/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { gettingStartedHubsEntryPoint } from '@jira/spa-apps__servicedesk-getting-started-page/src/gettingStartedHubsEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskGettingStartedHubsRoute } from '@jira/router-routes__servicedesk-getting-started-page-routes/src/servicedeskGettingStartedHubsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { HubsSkeleton } from '@jira/platform__skeletons/src/ui/getting-started-page/HubsSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const hubsPageEntryPoint = createPageEntryPoint({
	main: gettingStartedHubsEntryPoint,
});

export const servicedeskGettingStartedHubsRouteEntry: Route = createEntry(
	servicedeskGettingStartedHubsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-getting-started-hubs-load',
		skeleton: HubsSkeleton,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
		],

		entryPoint: () => (fg('solution_composer_master') ? hubsPageEntryPoint : undefined),

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		bifrost: {
			bifrostGroup: 'shell-only',

			enabled: true,
		},
	}),
);
